import { useState } from 'react'
import { useForm } from 'react-hook-form'
import { useLocation, useNavigate, useOutletContext } from 'react-router-dom'
import { useTranslation } from 'react-i18next'
import { nextPage } from 'components/RCPro/helpers/nav'
import { isValidIBAN } from 'ibantools'
import api from 'helpers/api'
import Input from 'components/common/Input/Input'
import InputError from 'components/common/InputError/InputError'
import Arrow from 'components/assets/icons/Arrow'
import Button from 'components/common/Button/Button'
import Spinner from 'components/common/Spinner/Spinner'
import ResponseMessage from 'components/common/ResponseMessage/ResponseMessage'
import { formParams } from 'constants/inputValidation'
import style from '../Payment.module.scss'

const IbanForm = ({ state }) => {
  const navigate = useNavigate()
  const { pathname } = useLocation()
  const { t } = useTranslation()
  const { nextPageTransition } = useOutletContext()
  const { transfer, layout } = state.texts
  const [ errorMessage, setErrorMessage ] = useState(false)
  const [ isSpinnerLoading, setIsSpinnerLoading ] = useState(false)

  // Initialize form
  const required = t('mainReporting:form.mandatory')
  const {
    register,
    formState: { errors, isValid },
    handleSubmit,
  } = useForm({
    ...formParams,
    values: {
      owner: '',
      iban: ''
    },
  })

  // Submit form
  const onSubmit = handleSubmit(async data => {
    try {
      setErrorMessage(false)
      setIsSpinnerLoading(true)
      const paymentPlan = state.annual ? 'year' : 'month'

      const res = await api.post({
        url: '/adhesions/client',
        data: {
          contractType: state.contractType,
          email: state.email,
          birthdate: '20/01/2000',
          transactionHorodate: new Date(),
          firstPaymentDate: state.activation,
          paymentType: 'direct debit by Owen',
          paymentPlan,
          iban: data.iban.replace(/\s/g,''),
          areTermsAccepted: state.areTermsAccepted,
          adhesionStatus: 'pending',
          frequency: {
            paymentInterval: paymentPlan
          },
        },
        headers: { Authorization: `Bearer ${state.token}` },
      })

      if (res?.response && res?.response.compliance) {
        nextPage({ pathname, state, navigate, data:{ saveID: res.response.id } })
        nextPageTransition()
      } else {
        setErrorMessage(true)
      }
    } catch (error) {
      console.log({error})
      setErrorMessage(true)
    } finally {
      setIsSpinnerLoading(false)
    }
  })


  return (
    <>
      {isSpinnerLoading && <Spinner />}

      <h1>{transfer?.title}</h1>

      {errorMessage && <ResponseMessage className={style.response} label={t('common:form.genericError')} />}

      <form onSubmit={onSubmit}>

        <Input
          error={errors.owner}
          register={register('owner', {
            required,
            validate: value => /[a-zA-ZÀ-ÿ-]{2,}/.test(value) || t('mainReporting:form.transfer.name.errors.pattern')
          })}
          label={t('mainReporting:form.transfer.name.label')}
          placeholder={t('mainReporting:form.transfer.name.placeholder')}
          disallowNumbers={true}
        />
        <InputError error={errors.owner} />


        <Input
          error={errors.iban}
          register={register('iban', {
            required,
            validate: value => isValidIBAN(value.replace(/\s/g,'')) || t('mainReporting:form.transfer.iban.errors.pattern')
          })}
          label={t('mainReporting:form.transfer.iban.label')}
          placeholder={t('mainReporting:form.transfer.iban.placeholder')}
        />
        <InputError error={errors.iban} />


        <Button
          label={<>{layout?.next} <Arrow /></>}
          onClick={handleSubmit}
          type="primary"
          disabled={!isValid}
        />

      </form>
    </>
  )
}
export default IbanForm
